import AddPersonalTimeDialog from './AddPersonalTimeDialog.view';

export default AddPersonalTimeDialog;
